import { render, staticRenderFns } from "./expertFee.vue?vue&type=template&id=48514a9c&scoped=true"
import script from "./expertFee.vue?vue&type=script&lang=js"
export * from "./expertFee.vue?vue&type=script&lang=js"
import style0 from "./expertFee.vue?vue&type=style&index=0&id=48514a9c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48514a9c",
  null
  
)

export default component.exports